import React from 'react'

// styles
import { imageCircle, imageCircleHoverBorder } from './styles/styles.css'

// components
import { cssClass } from '../../../shared/utils/styles'
import { ImageFit } from './ImageFit.component'

interface Props {
  src: string
  alt: string
  imageContainerCss?: string[]
  imageCss?: string[]
  size?: number | string
  hoverBorder?: boolean
}

export const ImageCircle: React.FC<Props> = ({
  src,
  alt,
  imageContainerCss = [],
  imageCss = [],
  size = '100%',
  hoverBorder = false,
}) => {
  const sizes = typeof size === 'number' ? `${size}px` : size
  return (
    <div
      style={{ width: size, height: size }}
      className={cssClass([
        imageCircle,
        ...imageContainerCss,
        hoverBorder ? imageCircleHoverBorder : '',
      ])}
    >
      <ImageFit
        src={src}
        alt={alt}
        className={cssClass(imageCss)}
        loading="eager"
        sizes={sizes}
      />
    </div>
  )
}
